import React, { useState } from "react";
import AutoGridLayout from "../../../../components/ModuleCommon/FormBuilder/AutoGridLayout";
import FieldInput from "../../../../components/ModuleCommon/FormBuilder/FieldInput";
import FieldDropdown from "../../../../components/ModuleCommon/FormBuilder/FieldDropdown";
import FieldCheckbox from "../../../../components/ModuleCommon/FormBuilder/FieldCheckbox";
import Button from '../../../../components/ACS-Dashboard/ACS-Blocks/Button';

const FormMessages = () => {
  const [draftFormData, setDraftFormData] = useState([
    { id: "itemNumber", label: "Item number/SKU", type: "text", value: "Macbook Pro 2021 14”" },
    { id: "itemUPC", label: "Item UPC", type: "text", value: "Macbook Pro 2021 14”" },
    { id: "personalShipment", label: "Personal Shipment or contains hazardous goods", type: "checkbox", value: false },
    { id: "itemDescription", label: "Item description", type: "textarea", value: "Macbook Pro 2021 14”" },
    { id: "itemQuantity", label: "Item quantity", type: "text", value: "" },
    { id: "itemType", label: "Item Type", type: "dropdown", value: "", options: ["Electronics", "Clothing", "Accessories"] },
    { 
      id: "price", 
      label: "Price", 
      type: "group", 
      components: [
        { id: "priceValue", type: "text", placeholder: "Value", value: "1000" }, 
        { id: "priceCurrency", type: "dropdown", value: "$", options: ["$", "€", "₹"] },
        { id: "priceUnit", type: "dropdown", value: "Per item", options: ["Per item", "Per kg"] }
      ] 
    },
    { 
      id: "discount", 
      label: "Discount", 
      type: "group", 
      components: [
        { id: "discountValue", type: "text", placeholder: "Value", value: "10" }, 
        { id: "discountUnit", type: "dropdown", value: "$", options: ["$", "%"] }
      ] 
    },
    { id: "comments", label: "Comments", type: "textarea", value: "This is the new creation of Apple..." },
  ]);

  const handleDraftChange = (id, newValue, parentId = null) => {
    setDraftFormData((prev) =>
      prev.map((field) => {
        if (parentId) {
          if (field.id === parentId) {
            return {
              ...field,
              components: field.components.map((component) =>
                component.id === id ? { ...component, value: newValue } : component
              ),
            };
          }
          return field;
        } else {
          return field.id === id
            ? { ...field, value: field.type === "checkbox" ? Boolean(newValue) : newValue }
            : field;
        }
      })
    );
  };

  return (
   <div className="w-full bg-white rounded-md shadow-lg p-3">
      <h2 className="text-2xl font-bold text-gray-900 mb-4">Add an Item</h2>

      <AutoGridLayout fields={draftFormData}>
  {/* ✅ Display Item Number and Item UPC in the Same Row */}
  <div className="grid grid-cols-2 gap-4">
    {draftFormData.slice(0, 2).map((field) => (
      <div key={field.id} className="col-span-1">
        <label className="block text-gray-700 text-sm font-medium mb-1">{field.label}</label>
        <FieldInput
          type={field.type}
          value={field.value}
          onChange={(val) => handleDraftChange(field.id, val)}
        />
      </div>
    ))}
  </div>

  {/* ✅ Display Item Description and Item Quantity in the Same Row */}
  <div className="grid grid-cols-2 gap-4">
    {draftFormData.slice(3, 5).map((field) => (
      <div key={field.id} className="col-span-1">
        <label className="block text-gray-700 text-sm font-medium mb-1">{field.label}</label>
        <FieldInput
          type={field.type}
          value={field.value}
          onChange={(val) => handleDraftChange(field.id, val)}
        />
      </div>
    ))}
  </div>

  {/* ✅ Display Personal Shipment Checkbox and Item Type Dropdown in the Same Row */}
  <div className="grid grid-cols-2 gap-4">
    <div className="col-span-1 flex items-center">
      <FieldCheckbox
        checked={Boolean(draftFormData[2].value)}
        onChange={(e) => handleDraftChange(draftFormData[2].id, e.target.checked)}
      />
      <label className="ml-2 text-gray-700 text-sm font-medium">
        {draftFormData[2].label}
      </label>
    </div>
    <div className="col-span-1">
      <label className="block text-gray-700 text-sm font-medium mb-1">{draftFormData[5].label}</label>
      <FieldDropdown
        value={draftFormData[5].value}
        options={draftFormData[5].options}
        onChange={(val) => handleDraftChange(draftFormData[5].id, val)}
      />
    </div>
  </div>

  {/* ✅ Render the Rest of the Fields Below Normally */}
  {draftFormData.slice(6).map((field) => (
    <div key={field.id} className="col-span-1">
      <label className="block text-gray-700 text-sm font-medium mb-1">{field.label}</label>
      {field.type === "text" || field.type === "textarea" ? (
        <FieldInput
          type={field.type}
          value={field.value}
          onChange={(val) => handleDraftChange(field.id, val)}
        />
      ) : field.type === "dropdown" ? (
        <FieldDropdown
          value={field.value}
          options={field.options}
          onChange={(val) => handleDraftChange(field.id, val)}
        />
      ) : field.type === "group" ? (
        <div className="flex space-x-2">
          {field.components.map((component) =>
            component.type === "text" ? (
              <FieldInput
                key={component.id}
                type="text"
                placeholder={component.placeholder}
                value={component.value}
                onChange={(val) => handleDraftChange(component.id, val, field.id)}
              />
            ) : (
              <FieldDropdown
                key={component.id}
                value={component.value}
                options={component.options}
                onChange={(val) => handleDraftChange(component.id, val, field.id)}
              />
            )
          )}
        </div>
      ) : null}
    </div>
  ))}
</AutoGridLayout>

      {/* ✅ Submit Button */}
      <div className="mt-6 mb-6">
        <Button text="Submit" aria-label="Submit" />
      </div>
    </div>
  );
};

export default FormMessages;